import { ReactElement, KeyboardEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldFillIcon } from '@navikt/aksel-icons';
import { Routes } from '../../enums/Routes';
import classes from './SystemAdminTopBar.module.css';

const BANNER_TEXT = 'Du er i systemadministrasjon. Klikk her for å gå tilbake til Trustpulse';
const BANNER_ARIA_LABEL = 'Gå tilbake til Trustpulse';

export const SystemAdminTopBar = (): ReactElement => {
  const navigate = useNavigate();

  const navigateToDashboard = () => {
    navigate(Routes.Dashboard);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      navigateToDashboard();
    }
  };

  return (
    <div
      className={classes.banner}
      onClick={navigateToDashboard}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={BANNER_ARIA_LABEL}
    >
      <div className={classes.content}>
        <img
          src="/TrustpulseLogo.png"
          alt="Trustpulse"
          className={classes.logo}
        />
        <ShieldFillIcon className={classes.icon} aria-hidden="true" />
        <span className={classes.text}>{BANNER_TEXT}</span>
      </div>
    </div>
  );
};
